import React, { useState } from "react";
import "./Home.css";
import Footer from "../Components/Footer/Footer";
import ClientDashboardWrap from "../Components/ClientDashboardWrap/ClientDashboardWrap";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown";
const ClientDashboardHome = () => {
  const [selectedYear, setSelectedYear] = useState("2023");
  return (
    <div className="clientdashboard__home_section">
      <div className="clientdashboard__home_wrapper">
        <div className="clientdashboard__home_heading">
          Hello! Welcome to Serene Tax!
        </div>
        <div className="clientdashboard__home_banner">
          <div className="clientdashboard__home_bannerleft">
            Your unique file number is: 106223
          </div>
          <div className="clientdashboard__home_bannerright">
            <span>Please select the tax year to continue:</span>
            <span className="clientdashboard__home_brdorpwrap">
              <CustomDropdown
                options={["2021", "2022", "2023"]}
                onSelect={(option) => setSelectedYear(option)}
                selectedLabel={selectedYear}
              />
            </span>
          </div>
        </div>
        <div className="clientdashboard__home_subheading">
          3 Easy Steps to process your tax return
        </div>
        <div className="clientdashboard__home_cards">
          <div className="clientdashboard__home_card">
            <div className="clientdashboard__home_cardbadge">1</div>
            <div className="clientdashboard__home_cardtext">
              Develop Your Information
            </div>
          </div>
          <div
            className="clientdashboard__home_card"
            style={{ background: "rgba(20, 176, 130, 0.15)" }}
          >
            <div
              className="clientdashboard__home_cardbadge"
              style={{ background: "rgba(20, 176, 130, 1)" }}
            >
              2
            </div>
            <div className="clientdashboard__home_cardtext">
              Upload Documents
            </div>
          </div>
          <div
            className="clientdashboard__home_card"
            style={{ background: "rgba(122, 67, 238, 0.1)" }}
          >
            <div
              className="clientdashboard__home_cardbadge"
              style={{ background: "rgba(140, 153, 209, 1)" }}
            >
              3
            </div>
            <div className="clientdashboard__home_cardtext">
              Analyse Returns & Make Payments
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardHome;
